export enum Collections {
  users = "users",
  images = "images",
  notes = "notes",
  tags = "tags",
  collaborators = "collaborators",
  avatars = "avatars",
}
